module.exports = __webpack_public_path__ + "assets/asap-cc820e.svg";